import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";

export const Provider = ({ children,theme, ...rest }) => {
  return (
    <MuiThemeProvider
      theme={theme}
      {...rest}
    >
      {children}
    </MuiThemeProvider>
  );
};
